import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import moment from "moment";

const fmt = require("indian-number-format");

export default function Details({ symbol }) {

  const socket = useContext(SocketContext);

  const [details, setDetails] = useState({
    Volume: null,
    AvgTradePrice: null,
    LastQty: null,
    LastTradeTs: null,
    LowerCircuit: null,
    UpperCircuit: null,
    OpenInterest: null,
    Expiry: null,
  });

  useEffect(() => {
    if (!socket || !symbol?.symbol_id) return;

    socket.emit("giverate", symbol.symbol_id);

    const tradeListener = (d) => {
      setDetails(prev => ({
        Volume: d.TotalVolume ?? prev.TotalVolume,
        AvgTradePrice: d.ATP ?? prev.ATP,
        LastQty: d.LTP ?? prev.LTP,
        LastTradeTs: d.Timestamp ?? prev.Timestamp,
        LowerCircuit: d.LC ?? prev.LC,
        UpperCircuit: d.UC ?? prev.UC,
        OpenInterest: d.Today_OI ?? prev.Today_OI,
        Expiry: d.Expiry ?? prev.Expiry,
      }));
    };

    socket.on(`trade${symbol.symbol_id}`, tradeListener);
    return () => socket.off(`trade${symbol.symbol_id}`, tradeListener);

  }, [socket, symbol]);

  return (
    <div className="px-4 py-3 space-y-2 border-t border-[var(--hover)]">

      <Row name="Volume" value={fmt.format(details.Volume)} />

      <Row name="Avg. trade price" value={fmt.format(details.AvgTradePrice)} />

      <Row name="Last traded quantity" value={details.LastQty} />

      <Row name="Last traded at" value={details.LastTradeTs} />

      <Row name="Lower circuit" value={fmt.format(details.LowerCircuit)} />

      <Row name="Upper circuit" value={fmt.format(details.UpperCircuit)} />

      <Row name="Open interest" value={fmt.format(details.OpenInterest)} />

      <Row name="Expiry" value={moment(symbol.expiry_date).format("DD-MMM-YY")} />

    </div>
  );
}

function Row({ name, value }) {
  return (
    <div className="flex justify-between items-center border-2 border-[var(--hover)] text-sm text-[var(--text)] py-2 px-2 rounded-md bg-[var(--background)]">
      <div className="text-[var(--text)] font-semibold" >{name}</div>
      <div className="font-bold">{value ?? "--"}</div>
    </div>
  );
}
